<template>
  <article
    class="bq-card"
    :class="[
      { 'bq-card-link': isLink },
      { 'bq-card-flip': flip },
      { mobile: isMobile },
    ]"
    @click="handleRouterPush(isLink, link)"
  >
    <!-- card 封面 -->
    <figure class="bq-card-cover" v-if="cover">
      <img :src="cover" alt="title" />
    </figure>

    <!-- card 封面插槽 -->
    <slot name="cover"></slot>

    <div
      class="bq-card-content"
      :class="{ link: isLink }"
      @click="handleRouterPush(isLink, link)"
    >
      <h3 v-if="title">{{ title }}</h3>

      <!-- 标签插槽 -->
      <slot name="tag"></slot>

      <!-- 内容插槽 -->
      <slot name="content"></slot>

      <!-- 扩展插槽 -->
      <slot name="extra"></slot>
    </div>
  </article>
</template>

<script>
import { isWirelessDevice } from '../../utils/utils';

export default {
  name: 'BQHorizontalCard',

  props: {
    cover: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    isLink: {
      type: Boolean,
      default: false,
    },
    link: String, // 内容区域的点击
    flip: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isMobile: false,
    };
  },

  created() {
    this.isMobile = isWirelessDevice();
  },

  methods: {
    handleRouterPush(isLink, path) {
      if (!isLink) {
        return;
      }

      // this.$router.push(path);
      location.href = path;
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
